


import React from 'react';
import './Genz.css';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from "../auth-config";

function GenZSignUp() {
    const { instance } = useMsal();

    const handleLogin = () => {
            instance.loginRedirect(loginRequest).catch(e => {
                console.log(e);
            });
    }
  return (
    <div className="container">
       <h1>GEN Assist</h1>
        <div className="sso-buttons">
        <button>
          <img src="google-icon.svg" alt="Google" /> Sign in with Google
        </button>
        <button>
          <img src="apple-icon.svg" alt="Apple" /> Sign in with Apple
        </button>
        <button onClick={()=>handleLogin()}>
          <img src="microsoft-icon.svg" alt="Microsoft"  /> Sign in with Microsoft
        </button>
        <button>
          <img src="facebook-icon.svg" alt="Facebook" /> Sign in with Facebook
        </button>
      </div>
    </div>
  );
}

export default GenZSignUp;

/* App.css */


